module.exports = __webpack_public_path__ + "media/images/home/aim-dfc9afa880c95db68c829c37fe7614e1.svg";